<div class="dashboard-container">
  <div class="dashboard-header">
    <h1>ParkPro</h1>
    <p></p>
  </div>

  <div class="dashboard-content">
    <div class="dashboard-section">
      <h2>Updated Attendant Portal</h2>
      <p>
        The updated attendant portal is a comprehensive solution for managing parking operations,
        invoicing, tenant relationships, and reporting. This dashboard provides quick access to
        all the tools you need to efficiently manage your parking facilities.
      </p>
    </div>

    <div class="dashboard-section">

        <!-- Location Switcher for users with prerelease access -->
        <div class="card-content" *ngIf="hasPreReleaseAccess">
          <h3>Location Switcher</h3>
          <p>Switch between different locations</p>
          <div class="location-switcher-container">
            <app-location-switcher></app-location-switcher>
          </div>
        </div>

        <!-- Location Display for users without prerelease access -->
        <div class="card-content" *ngIf="!hasPreReleaseAccess">
          <h3>Current Location</h3>
          <div class="location-display-container">
            <app-location-display></app-location-display>
          </div>
        </div>

    </div>

    <div class="dashboard-cards">

      <div class="dashboard-card" routerLink="/surepark/daily-summary-import">
        <div class="card-icon">
          <i class="pi pi-upload"></i>
        </div>
        <div class="card-content">
          <h3>Daily Summary Import</h3>
          <p>Import and process daily summary data</p>
        </div>
      </div>

      <div class="dashboard-card" routerLink="/surepark/member-ids-report">
        <div class="card-icon">
          <i class="pi pi-id-card"></i>
        </div>
        <div class="card-content">
          <h3>Member IDs Report</h3>
          <p>View and manage member identification reports</p>
        </div>
      </div>

      <div class="dashboard-card" routerLink="/reports/run">
        <div class="card-icon">
          <i class="pi pi-chart-bar"></i>
        </div>
        <div class="card-content">
          <h3>Run Reports</h3>
          <p>Generate and view various operational reports</p>
        </div>
      </div>

      <div class="dashboard-card" routerLink="/sequence-management">
        <div class="card-icon">
          <i class="pi pi-sort-numeric"></i>
        </div>
        <div class="card-content">
          <h3>Sequence Management</h3>
          <p>Manage and configure sequence numbering</p>
        </div>
      </div>
    </div>

    <div class="dashboard-section">
      <h2>Quick Links</h2>
      <div class="quick-links">
        <a routerLink="/surepark/accounts-validity-update">Account Validity Update</a>
        <a routerLink="/surepark/terminate-contacts">Terminate Contacts</a>
        <a routerLink="/surepark/surepark-merge">Merge Tool</a>
        <a routerLink="/performance-metrics">Performance Metrics</a>
        <a routerLink="/sequence-management">Sequence Management</a>
      </div>
    </div>
  </div>

  <div class="version-footer">
    <p class="version-info">
      Version: {{version}} | Built: {{buildTimestamp}} | Build Mode: {{buildMode}} | Environment: {{environment}}
    </p>
  </div>
</div>
